<template>
    <div>
      <!--
        <b-alert :variant="type" :show="show">
            {{ message }}
        </b-alert>
        -->
    </div>
</template>

<script>
    export default {
        data () {
            return {
                message: null,
                type: 'success',
                show: false
            }
        },
        methods: {
            setValue: function(obj) {
                this.message = obj.message;
                this.type = obj.type ? obj.type : 'info';
                this.show = true;

                switch(this.type) {
                  case 'danger':
                    this.$toastr.e(this.message);
                  break;
                  case 'success':
                    this.$toastr.s(this.message);
                  break;
                  case 'info':
                    this.$toastr.i(this.message);
                  break;
                }
            },
            close(){
                this.message = null;
                this.type = null;
                this.show = false;
            }
        },
        created: function() {
            this.$parent.$on('alert', this.setValue);
            this.$parent.$on('alert_close', this.close);
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Alerts.vue